"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageSchema = exports.accountLanguageSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const languageType = [...data_1.languageCodes];
exports.accountLanguageSchema = yup_lib_1.default.string().oneOf(data_1.languageCodes).required();
exports.languageSchema = yup_lib_1.default.object().shape({
    language: yup_lib_1.default.string().oneOf(data_1.languageCodes).required()
});
